/* eslint-disable @wyz/module/no-relative-import */
import { Flex, Icon, Navbar } from '@wyz/ui';
import clsx from 'clsx';
import { useEffect, useEffectEvent, useRef, useState } from 'react';
import { PlatformLogo, TopNavbarPortal } from '~/common/components';
import { useConfig, useTheme } from '~/common/context';
import './navbar-top.scss';
import TopNavRightSideNavItem from './top-nav-right-side-nav-item';
import { usePersistedState } from '@wyz/utils';
import { PERMANENT_LS_KEYS } from '~/purchase/helpers';
const NavbarTop = () => {
  const {
    navbarPosition,
    topNavbarBreakpoint,
    isNavbarVerticalCollapsed,
    setConfig,
  } = useTheme();

  const [showDropShadow, setShowDropShadow] = useState(false);
  const [isCollapsed, setIsCollapsed] = usePersistedState<boolean>(
    PERMANENT_LS_KEYS.NAVBAR_COLLAPSED_LS_KEY,
    true,
  );
  const updateNavbarState = useEffectEvent((isCollapsed: boolean) => {
    setConfig('isNavbarVerticalCollapsed', isCollapsed);
    setConfig('showBurgerMenu', !isCollapsed);
  });
  useEffect(() => {
    if (isCollapsed !== isNavbarVerticalCollapsed) {
      updateNavbarState(isCollapsed);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCollapsed]);

  const handleBurgerMenu = () => {
    const newState = !isCollapsed;
    setIsCollapsed(newState);
    setConfig('isNavbarVerticalCollapsed', newState);
    setConfig('showBurgerMenu', !newState);
  };

  const setDropShadow = () => {
    const el = document.documentElement;
    setShowDropShadow(el.scrollTop > 0);
  };

  useEffect(() => {
    window.addEventListener('scroll', setDropShadow);
    return () => window.removeEventListener('scroll', setDropShadow);
  }, []);

  return (
    <Navbar
      className={clsx(
        'navbar-glass fs-xxs navbar-top fixed-navbar sticky-kit',
        {
          'navbar-glass-shadow': showDropShadow,
        },
      )}
      expand={
        navbarPosition === 'top' ||
        navbarPosition === 'combo' ||
        navbarPosition === 'double-top'
          ? topNavbarBreakpoint
          : true
      }
    >
      <NavbarTopElements
        navbarPosition={navbarPosition}
        handleBurgerMenu={handleBurgerMenu}
      />
    </Navbar>
  );
};

type NavbarTopElementsProps = {
  navbarPosition: string;
  handleBurgerMenu: () => void;
};
const NavbarTopElements = ({
  navbarPosition,
  handleBurgerMenu,
}: NavbarTopElementsProps) => {
  const burgerMenuRef = useRef(null);
  const theme = useTheme();

  const { environment } = useConfig();
  return (
    <>
      <Navbar.Toggle
        ref={burgerMenuRef}
        className={clsx('toggle-icon-wrapper me-md-3 me-2', {
          [`d-${String(theme.navbarBreakPoint)}-none`]:
            navbarPosition === 'vertical',
        })}
        as='div'
      >
        <button
          className='navbar-toggler-humburger-icon btn btn-link d-flex flex-center'
          onClick={handleBurgerMenu}
          id='burgerMenu'
        >
          <Icon
            icon={theme.isNavbarVerticalCollapsed ? 'opened-burger' : 'close'}
          />
        </button>
      </Navbar.Toggle>
      <Flex alignItems='center'>
        <PlatformLogo id='topLogo' />
      </Flex>
      {environment !== 'prod' && environment && (
        <span className={'env-pill'}>{environment}</span>
      )}
      <TopNavbarPortal />

      <TopNavRightSideNavItem />
    </>
  );
};

export default NavbarTop;
